module.exports = __webpack_public_path__ + "static/media/theoryQ2_1.558f0dab.mp4";